window.App = window.App || {};
window.woopra = window.woopra || {
  track: function() {
    // Optionally, you can log or silently ignore
    console.log('Woopra not loaded, track called:', arguments);
  }
};

App.init = function() {
  // primary navigation initialization
  $('#masthead').on('click tap', '.menu-toggle', function(e) {
    e.preventDefault();

    var _this = $(this)
      , topMenu = $('#top-menu')
      ;
    _this.toggleClass('toggled-on');
    topMenu.toggleClass('is-open');
  });

  jQuery(function($) {
    // woopra tracking proxy
    function track(eventName, data) {
      if ('track' in woopra) {
        woopra.track(eventName, data);
      }
      console.log('woopra.track', eventName, data);
    };

    // track header nav links
    $('#member-nav')
      .on('mouseenter', 'a', function() {
        track('header-nav-hover', {
          'link-title': $(this).text().trim(),
          'link-url': $(this).attr('href').trim(),
        });
      })
      .on('click', 'a', function() {
        track('header-nav-click', {
          'link-title': $(this).text().trim(),
          'link-url': $(this).attr('href').trim(),
        });
      });
  });

  $('.menu-item-has-children i').on('click tap', function() {
    $(this).next().next().slideToggle();
    $(this).toggleClass('icon-minus');
  });

  // on authorization forms (login, reg, forgot password, unlock)
  // any error messages should be removed when users begin typing again.
  // targeting new_user should prevent running on other forms and only removing
  // the auth-flash-container restricts it to messages in the form and not at the top of the screen
  $('.new_user input').one('keyup', function() {
    $('.auth-flash-container').remove();
  });

  // on the devise forms we want to hide errors if a user is trying to fix it.
  // this script should only target that form, but selector can be updated for all devise forms
  $('.new_user').each(function() {
    var watchEvents = 'keyup change';

    // wait for changes to input elements
    $(this).find('input').on(watchEvents, function() {
      // if it's empty (from tabbing in) don't unbind yet
      if(!$(this).val()) {
        return;
      }

      // unbind manually since 'one' doesn't work with multiple events
      $(this).off(watchEvents);

      hideErrors(this);
    });

    // find dropdown placeholder
    $(this).find("[data-react-class*='MemberSearchOnRegistration']").bind('membersearchreg-change', function() {
      hideErrors(this);
    });

    // hide errors and reset style for the element by targeting elements in the form group
    function hideErrors(el) {
      // grab group
      var formGroup = $(el).closest('.form-group');

      // make it look like errors are gone without changing the markup structure
      formGroup.find('.has_error').removeClass('has_error');
      formGroup.find('.field-level-error').remove();
    }
  });

  // target only the edit_user form once users are logged in
    $('.edit-user-info').submit(function(e) {
        var panes = $(this).find('.tab-pane');

        // allow first pane to submit on its own
        // so server can choose where to redirect,
        // and render the iframe to alert WP to the
        // session change.
        if(!panes.length || panes.eq(0).is('.active')) {
          // Don't submit data in other tabs.
          // This avoids conflict if you (for instance) edit a user's role
          // on the first tab, but we're also submitting their custom permission
          // set from the second tab.
          // In this case, we only want the role change to take affect, not the
          // permission list changes.
          panes.not('.active')
            .find('input, select, textarea')
            .remove();

          return true;
        }

        // HACK: Force server validation of password fields if we're submitting this part
        // of the form. Avoids the issue where you can leave them blank, click submit
        // and it says things 'updated properly'.
        // Forces server to validate by just putting an invalid value into the password input.
        // TODO:
        // - Refactor user form so each section is on its own page
        // - Add `required` props to these fields on the client side.
        var viewingPasswordResetSection     = panes.filter('.active').attr('id') == 'password-reset',
            emptyPasswordResetFields        = panes.filter('.active')
                                                   .find('input[type=password]')
                                                   .filter(function() { return $(this).val() == ""; }),
            submittingWithoutARequiredField = emptyPasswordResetFields.length > 0,
            forceValidation = 'VALID?';
        if(viewingPasswordResetSection && submittingWithoutARequiredField) {
          emptyPasswordResetFields.val(forceValidation);
        }

        // handle submit via ajax
        e.preventDefault();

        // submit data not in a panel and the active panel.
        // ignore other fields.
        // add commit=Save to trigger update
        var data = panes.filter('.active').find('input, select, textarea')
                .add($(this).find('input:not(.panel input), select:not(.panel select), textarea:not(.panel textarea)'))
                .serialize() + "&commit=Save",
            url = $(this).attr('action');

        $.ajax({
            url: url,
            data: data,
            dataType: 'json',
            method: 'POST',
            success: function(data, status, xhr) {
                updateMarkup(data);
            },
            error: function(xhr, status, message) {
                updateMarkup(xhr.responseJSON);
            }
        });

        function updateMarkup(data, message) {
            // update the active pane
            panes.each(function(i, val) {
                var pane = $(this);
                if(!pane.is('.active')) {
                    return;
                }

                var markup = $(data.markup).find('.tab-pane').eq(i).html();
                pane.html(markup);

                var label_floater = new App.LabelFloater();
                label_floater.initializeInputs();

                if(data.flash) {
                    $('<div class="alert alert-success">' + data.flash + '</div>').prependTo(pane);

                    // remove alerts in 15 seconds
                    setTimeout(function() { $('.alert-success').hide(); }, 15000);
                }
            });
        }

        return false;
    });

  $('.password-requirements').each(function() {
      var container = $(this),
          form = container.is('form') ? container : container.closest('form'),
          manageSubmitState = !form.find('.panel-columns').length,
          submit = form.find(':submit');

      form.on('keyup change blur', '.password-requirements__target input, .password-requirements__confirm input', checkPassword);

      // disable buttons to start
      if(manageSubmitState) {
          submit.attr('disabled', 'disabled');
      }

      function checkPassword() {
          let validCount = 0,
              validClass = 'requirements-valid',
              confirmInvalidClass = 'password-requirements__confirm--invalid',
              confirmValidClass = 'password-requirements__confirm--valid',
              targetValidClass = 'password-requirements__target--valid',
              confirm = container.find('.password-requirements__confirm'),
              confirmInput = confirm.find('input'),
              target = container.find('.password-requirements__target'),
              targetInput = target.find('input'),
              items = container.find('.password-requirements__display li').filter('[data-pattern]');

          // validate target against rules
          if($(this)[0] === targetInput[0]) {
              // validate all
              items.each(function() {
                  let valid = false,
                      item = $(this),
                      regex = new RegExp(item.data('pattern')),
                      val = $.trim(targetInput.val());

                  if(regex.test(val)) {
                      valid = true;
                  }

                  if(valid) {
                      validCount++;
                      item.addClass(validClass);
                  }
                  else {
                      item.removeClass(validClass);
                  }
              });
          }
          // validate confirm against target
          else {
              validCount = items.filter('.' + validClass).length;

              let val = $(this).val(),
                  compareTo = targetInput.val().substring(0, val.length);

              if(val != compareTo) {
                  confirm.addClass(confirmInvalidClass).removeClass(confirmValidClass);
              }
              else {
                  confirm.removeClass(confirmInvalidClass).removeClass(confirmValidClass);
              }
          }

          // make sure all regexes are matched and that all fields have the same value
          if(validCount == items.length) {
              target.addClass(targetValidClass);

              // enable confirmation field
              confirmInput.removeAttr('disabled');

              if($.unique(targetInput.add(confirmInput).map(function() { return $.trim($(this).val()); })).length == 1) {
                  if(manageSubmitState) {
                      submit.removeAttr('disabled');
                  }

                  confirm.addClass(confirmValidClass);
              }
              else if(manageSubmitState) {
                  submit.attr('disabled', 'disabled');
              }
          }
          else {
              confirm.removeClass(confirmValidClass);
              target.removeClass(targetValidClass);
              confirmInput.attr('disabled', 'disabled');

              if(manageSubmitState) {
                  submit.attr('disabled', 'disabled');
              }
          }
      }
  });

  // remove success alerts after 15 seconds
  setTimeout(function() { $('.alert-success').not('.keep').remove(); }, 15000);

  // Open tooltip links in a new window
  $(document).on('click', ".tooltip a", function() {
    window.open(this.href);
    return false;
  })
}

$(document).on('turbo:load', function() {
  App.init();
});

// -------- always on 😳 --------

$(document).on("focus", "[data-behavior=datepicker]", function() {
  $(this).datepicker({
    format: 'mm/dd/yyyy',
    orientation: 'bottom',
    minViewMode: 'days',
    maxViewMode: 'years',
    autoclose: true,
    todayHighlight: true
  });
});

$(document).on("click", "[data-behavior=datepicker-icon]", function() {
  $(this).closest('div').find('input').focus();
});

// -------- monkey patches --------

String.prototype.humanize = function() {
  return this.underscore().toLowerCase().
    replace(/[_-]/g, ' ').
    replace(/(?:^)\S/g, function(a) {
      return a.toUpperCase();
    });
};

String.prototype.titleize = function() {
  return this.underscore().toLowerCase().
    replace(/[_-]/g, ' ').
    replace(/(?:^|\s)\S/g, function(a) {
      return a.toUpperCase();
    });
};

String.prototype.underscore = function() {
  return this.charAt(0).toLowerCase() + this.slice(1).replace(/([A-Z])/g, ($1) => `_${$1.toLowerCase()}`)
}
